import * as React from "react";

interface HeaderLogoProps extends React.SVGProps<SVGSVGElement> {
    color?: string;
    width?: number | string;
    height?: number | string;
}

const HeaderLogo = ({ color = "#E6E8FF", width = 29, height = 24, ...props }: HeaderLogoProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 29 24"
        fill="none"
        {...props}
    >
        <path
            d="M23.4601 3.7052C23.1808 3.42591 22.9016 3.14663 22.6223 2.86734C21.7844 1.97363 20.8907 1.07991 19.7735 0.521338C18.4888 -0.148949 17.0924 0.0186178 15.696 0.0186178C13.5734 0.0186178 8.26693 0.0186178 5.13892 0.0186178L7.2615 2.86734C11.1157 2.86734 17.1482 2.86734 19.9411 2.86734C21.1141 2.86734 22.1196 3.09077 23.0691 3.7052C23.2367 3.76106 23.4043 3.76106 23.4601 3.7052Z"
            fill={color}
        />
        <path
            d="M25.806 8.28539C25.5268 8.00611 25.2475 7.72682 24.9682 7.44754C24.1303 6.55382 23.2366 5.6601 22.1195 5.10153C20.8347 4.43124 19.4383 4.59882 18.0419 4.59882C16.1986 4.59882 11.7858 4.59882 8.65784 4.59882L10.7804 7.44754C14.5787 7.44754 19.7735 7.44754 22.3429 7.44754C23.5159 7.44754 24.5213 7.67096 25.4709 8.28539C25.5826 8.34125 25.6943 8.34125 25.806 8.28539Z"
            fill={color}
        />
        <path
            d="M28.4314 12.754C28.1521 12.4747 27.8728 12.1955 27.5935 11.9162C26.7557 11.0225 25.862 10.1287 24.7448 9.57016C23.4601 8.89987 22.0636 9.06745 20.6672 9.06745C18.9356 9.06745 15.1373 9.06745 12.0652 9.06745L14.1878 11.9162C17.8743 11.9162 22.5664 11.9162 24.9124 11.9162C26.0854 11.9162 27.0908 12.1396 28.0404 12.754C28.208 12.8099 28.3197 12.8657 28.4314 12.754Z"
            fill={color}
        />
        <path
            d="M4.91541 20.2948C5.19469 20.5741 5.47398 20.8534 5.75327 21.1327C6.59113 22.0264 7.48484 22.9201 8.60199 23.4787C9.88671 24.149 11.2831 23.9814 12.6796 23.9814H23.2366L21.114 21.1327C17.2599 21.1327 11.2273 21.1327 8.43442 21.1327C7.26142 21.1327 6.25598 20.9093 5.30641 20.2948C5.13883 20.239 5.02712 20.239 4.91541 20.2948Z"
            fill={color}
        />
        <path
            d="M2.56946 15.7144C2.84874 15.9937 3.12803 16.273 3.40732 16.5522C4.24518 17.446 5.13889 18.3397 6.25604 18.8982C7.54076 19.5685 8.93719 19.401 10.3336 19.401H19.7177L17.5951 16.5522C13.7968 16.5522 8.60205 16.5522 6.03261 16.5522C4.85961 16.5522 3.85417 16.3288 2.9046 15.7144C2.79288 15.6585 2.68117 15.6585 2.56946 15.7144Z"
            fill={color}
        />
        <path
            d="M0 11.1901C0.279287 11.4694 0.558574 11.7487 0.83786 12.0279C1.67572 12.9217 2.56944 13.8154 3.68659 14.374C4.97131 15.0442 6.36774 14.8767 7.76417 14.8767H16.3662L14.2436 12.0279C10.557 12.0279 5.86502 12.0279 3.51902 12.0279C2.34601 12.0279 1.34057 11.8045 0.391 11.1901C0.223428 11.1342 0.111715 11.1342 0 11.1901Z"
            fill={color}
        />
    </svg>
);
export default HeaderLogo;
